
const config = {
    // baseUrl: "http://localhost:3000",
    baseUrl: "https://dev.rohautism.org",  //This for production url
    apiBaseUrl: "https://backoffice.rohautism.org"
  };
  
  export default config;
  